// Location flag contants (funcIds)
export const LOCATION_MOCK_SERVICES = 'mockServices';

// Group names
export const GROUP_VS_ENVIRONMENTS = 'VS Environments';
export const GROUP_CLOUD_LOCATIONS = 'Cloud Locations';

// CraneLocationDto
export interface CraneLocation {
  harborId: string;
  title: string;
  harborName: string;
  provider: string;
  shipName: string;
  shipId: string;
  types: string[];
  isKubernetes: boolean;
  metadata: any;
  limits: ILimits;
  capabilities: any;
  funcIds: string[];
  sandbox: boolean;
  locationId: number;
}

interface ILimits {
  threadsPerEngine?: number;
  concurrency?: number;
  engines?: number;
  duration?: number;
}

interface IMetaData {
  portRange: string;
  containerResources: IContainerResources;
}

interface IContainerResources {
  cpuRequest: string;
  cpuLimit: string;
  memRequestMb: string;
  memLimitMb: string;
  javaMaxHeapMb: string;
  javaMinHeapMb: string;
}
